export default __webpack_public_path__ + "static/media/movie.845c6921.png";